<template>
  <div class="maintenance-page">
    <div class="maintenance-card">
      <img
        class="maintenance-logo"
        src="@/assets/logo.png"
        alt="LK Logo"
      />
      <h1 class="maintenance-title">系统维护中</h1>
      <p class="maintenance-desc">
        我们正在进行系统升级和优化，以便为你提供更好的服务。
      </p>
      <p class="maintenance-sub">
        请稍后再试，或联系管理员获取更多信息。
      </p>
      <button class="maintenance-btn" @click="reloadPage">
        刷新页面
      </button>
    </div>
  </div>
</template>

<script setup>
const reloadPage = () => {
  window.location.reload();
};
</script>

<style scoped>
.maintenance-page {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at top, #2c1b0a 0, #0e0a05 55%, #050302 100%);
  color: #f5f5f5;
  padding: 24px;
  box-sizing: border-box;
}

.maintenance-card {
  max-width: 520px;
  width: 100%;
  padding: 40px 32px 48px;
  border-radius: 24px;
  background: linear-gradient(145deg, rgba(31, 22, 13, 0.98), rgba(10, 6, 3, 0.98));
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.8),
    0 0 0 1px rgba(255, 204, 128, 0.12);
  text-align: center;
  border: 1px solid rgba(255, 204, 128, 0.22);
}

.maintenance-logo {
  width: 88px;
  height: 88px;
  object-fit: contain;
  margin-bottom: 24px;
}

.maintenance-title {
  margin: 0 0 12px;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #ffdd9a;
}

.maintenance-desc {
  margin: 0 0 8px;
  font-size: 15px;
  line-height: 1.7;
  color: #f5f0e5;
}

.maintenance-sub {
  margin: 0 0 28px;
  font-size: 13px;
  line-height: 1.6;
  color: #c9b9a0;
}

.maintenance-btn {
  padding: 10px 28px;
  border-radius: 999px;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: linear-gradient(135deg, #ffcf7f, #ffb648);
  color: #3b230f;
  box-shadow:
    0 12px 30px rgba(255, 182, 72, 0.4),
    0 0 0 1px rgba(60, 35, 16, 0.6);
  transition: all 0.18s ease-out;
}

.maintenance-btn:hover {
  transform: translateY(-1px);
  box-shadow:
    0 16px 36px rgba(255, 182, 72, 0.55),
    0 0 0 1px rgba(60, 35, 16, 0.7);
}

.maintenance-btn:active {
  transform: translateY(0);
  box-shadow:
    0 8px 20px rgba(255, 182, 72, 0.35),
    0 0 0 1px rgba(60, 35, 16, 0.8);
}

@media (max-width: 480px) {
  .maintenance-card {
    padding: 28px 20px 32px;
    border-radius: 18px;
  }

  .maintenance-title {
    font-size: 22px;
  }

  .maintenance-desc {
    font-size: 14px;
  }

  .maintenance-sub {
    font-size: 12px;
  }
}
</style>

